<!-- #738: Ankuendigung verfassen, aendern und korrigieren — EIN Template, drei Modi (mode()).
     Eigener Screen statt Overlay: sieben Sprach-Tabs plus Zielgruppe, Terminierung und
     Test-Versand sprengen einen Dialog (Entscheidung 1 der Spec).
     nx-detail-screen/nx-section gibt es auf 4.0.x nicht: nx-pageTitle-box + nx-headline-box-Abschnitte,
     Breadcrumbs nach notification-admin-detail.component.html. -->
<div [formGroup]="form" class="form">

  <nx-pageTitle-box
    [bcRootLvlLabel]="'core.announcement.breadcrumb.settings'"
    [bcRootLvlPath]="'/settings'"
    [bcRootLvl1Label]="'core.announcement.breadcrumb.list'"
    [bcRootLvl1Path]="'/settings/announcements'"
    [icon]="'icon-notification'"
    [label]="pageTitleKey()">
  </nx-pageTitle-box>

  <!-- Abschnitt 1: Typ -->
  <!-- Abschnittskoepfe in der Vorgabe-Erscheinung (gefuellter Balken) mit mt-2 und einem unten
       geschlossenen Inhaltsblock — dasselbe Kartenmuster wie notification-admin-detail (#737).
       Bewusst NICHT appearance="underline": das ist im Repo die Ebene-1-Erscheinung, einmal je
       Ansicht als deren eigener Titel (order-rent-details.component.html:1-4). Den Titel traegt
       hier nx-pageTitle-box, die vier Koepfe darunter sind Ebene 2.
       py-4 statt der py-3 der Detailseite: dort stehen dichte Lesezeilen, hier Felder mit
       Beschriftung. -->
  <!-- Bei CORRECT ganz ausgeblendet: der Server nimmt den Typ des Originals und ignoriert
       input.typeKey. Ein bedienbares Feld, dessen Eingabe verworfen wird, ist schlechter als
       kein Feld. Gesendet wird trotzdem der Wert der Vorlage — der Typ verlangt das Feld. -->
  @if (mode() !== 'CORRECT') {
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.typeHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-1">
    <!-- label kommt fertig uebersetzt vom Server (Argument locale) und laeuft deshalb NICHT durch die
         translate-Pipe. optionValue ist der typeKey. -->
    <nx-edit-select-v2-input
      formControlName="typeKey"
      [label]="'core.announcement.form.typeLabel'"
      [options]="typeOptions()"
      [optionValue]="'typeKey'"
      [optionLabel]="'label'"
      [placeholder]="'core.announcement.form.typePlaceholder'">
    </nx-edit-select-v2-input>

    <!-- Die E-Mail-Vorgabe wirkt direkt auf die Reichweite: eine Produktankuendigung erreicht per
         E-Mail nur, wer sie ausdruecklich aktiviert hat. -->
    @if (emailHintKey()) {
      <div class="text-[13px] text-[#848488]">{{ emailHintKey() | translate }}</div>
    }
  </div>
  }

  <!-- Abschnitt 2: Inhalt -->
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.contentHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4" formGroupName="content">
    <!-- Ein Tab je Locale, `de` zuerst. Der Tab-Kopf zeigt mit einem Punkt, welche Sprachen befuellt
         sind — sonst muesste man sieben Tabs durchklicken, um den Stand zu sehen. -->
    <p-tabView>
      @for (locale of locales; track locale) {
        <p-tabPanel [header]="(('core.announcement.form.locale.' + locale) | translate) + (isFilled(locale) ? ' •' : '')">
          <div [formGroupName]="locale" class="flex flex-col gap-3">
            <nx-edit-text-input
              formControlName="title"
              [label]="locale === requiredLocale
                ? 'core.announcement.form.titleLabelRequired'
                : 'core.announcement.form.titleLabel'"
              [placeholder]="'core.announcement.form.titlePlaceholder'">
            </nx-edit-text-input>

            <!-- Rich-Text nach der Allow-List aus §8.1. Der Editor kann bewusst nicht mehr,
                 als der Server erlaubt: was er nicht anbietet, entsteht auch ueber Tastatur
                 oder Einfuegen nicht, weil die Extensions dafuer gar nicht geladen sind. -->
            <!-- BEIDE Beschriftungen sind i18n-Schluessel; die Komponente uebersetzt selbst.
                 Bewusst NICHT die Asymmetrie von nx-textfield-input uebernommen, das den
                 placeholder roh nimmt und den label uebersetzt — genau daran stolpert man. -->
            <nx-announcement-body-input
              formControlName="body"
              [label]="'core.announcement.form.bodyLabel'"
              [placeholder]="'core.announcement.form.bodyPlaceholder'">
            </nx-announcement-body-input>
          </div>
        </p-tabPanel>
      }
    </p-tabView>

    <!-- Beim Rendern gilt exakte Uebereinstimmung, sonst Rueckfall auf `de`. Ein Empfaenger mit
         slowakischer Sprache bekommt also die deutsche Fassung, wenn `sk` fehlt — kein Fehler, aber
         gut zu wissen beim Verfassen. -->
    <div class="text-[13px] text-[#848488] mt-2">{{ 'core.announcement.form.fallbackHint' | translate }}</div>

    <!-- Maschinelle Vorbefuellung (Client-Dok §8.5). Zielsprachen sind ausschliesslich die LEEREN —
         damit kann kein handgeschriebener Text ueberschrieben werden. -->
    <div class="flex flex-row items-center gap-3 mt-3">
      <nx-default-button
        [style]="'light'"
        [disabled]="!canTranslate()"
        (click)="onTranslate()"
        [label]="translating()
          ? 'core.announcement.form.translatingAction'
          : 'core.announcement.form.translateAction'">
      </nx-default-button>

      <div class="text-[13px] text-[#848488]">
        @if (translationTargets().length === 0) {
          {{ 'core.announcement.form.translateAllFilledHint' | translate }}
        } @else {
          {{ 'core.announcement.form.translateDraftHint' | translate }}
        }
      </div>
    </div>

    <!-- Teilerfolg ist der Normalfall, nicht die Ausnahme: eine Oberflaeche, die nach vier von
         sechs Zielsprachen ein stilles „fertig" zeigt, verliert genau die Information, fuer die es
         diese Liste gibt (Client-Dok §8.5). Verzweigt wird auf `reason`, nicht auf `message` —
         die ist deutscher Servertext und darf sich aendern; gezeigt wird sie zusaetzlich, weil
         sie das betroffene Segment nennt. -->
    @if (translationFailures().length > 0) {
      <div class="text-[13px] text-[#c0123c] mt-2 flex flex-col gap-1">
        @for (failure of translationFailures(); track failure.locale) {
          <div>
            {{ ('core.announcement.form.locale.' + failure.locale) | translate }}:
            @if (failureKey(failure)) {
              {{ failureKey(failure) | translate }}
            } @else {
              {{ failure.message }}
            }
          </div>
        }
      </div>
    }

    @if (missingRequiredTitle()) {
      <div class="text-[13px] text-[#c0123c] mt-1">{{ 'core.announcement.form.errorMissingTitle' | translate }}</div>
    }
    @if (missingBodyLocales().length > 0) {
      <div class="text-[13px] text-[#c0123c] mt-1">
        {{ 'core.announcement.form.errorMissingBody' | translate:{ locales: missingBodyLocales().join(', ') } }}
      </div>
    }
    @if (bodyTooLongLocales().length > 0) {
      <div class="text-[13px] text-[#c0123c] mt-1">
        {{ 'core.announcement.form.errorBodyTooLong' | translate:{ locales: bodyTooLongLocales().join(', ') } }}
      </div>
    }
    <!-- Wortwoertlich vom Server. Der Screen haengt an framework_nexato_employee — das liest
         ein Kollege, kein Endnutzer. -->
    @if (serverErrors().length > 0) {
      <div class="text-[13px] text-[#c0123c] mt-2 flex flex-col gap-1">
        @for (message of serverErrors(); track message) {
          <div>{{ message }}</div>
        }
      </div>
    }
  </div>

  <!-- Abschnitt 3: Zielgruppe. Bei CORRECT ausgeblendet — der Server loest den Empfaengerkreis
       aus den Fan-out-Zeilen des Originals auf und ignoriert input.targeting. -->
  @if (mode() !== 'CORRECT') {
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.targetingHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-3">
    <!-- Nach dem Fan-out lehnt der Server Zielgruppe und Termin ab („targeting and scheduledAt are
         frozen once fan-out started"). Bedienbare Felder, deren Eingabe abgelehnt wird, waeren
         schlechter als ein Hinweis. -->
    @if (!beforeFanout() && mode() === 'EDIT') {
      <div class="text-[13px] text-[#848488]">{{ 'core.announcement.form.frozenAfterFanoutHint' | translate }}</div>
    } @else {
    <nx-edit-select-v2-input
      formControlName="targetingMode"
      [label]="'core.announcement.form.targetingLabel'"
      [options]="targetingModeOptions | arrayTranslate"
      [optionValue]="'value'"
      [optionLabel]="'label'">
    </nx-edit-select-v2-input>

    <!-- Genau eines von beidem: allTenants ODER eine nicht-leere tenantIds-Liste. Nur die
         MANDANTENWAHL haengt am Modus — der Rollenfilter unten NICHT, siehe dort. -->
    @if (targetingMode() === 'SELECTION') {
      <!-- optionValue ist tenantId, der KURZCODE — nicht id (UUID). Jeder Eintrag muss serverseitig
           einen echten Mandanten treffen, deshalb Auswahl statt Texteingabe. -->
      <nx-edit-multiselect-v2-input
        formControlName="tenantIds"
        [label]="'core.announcement.form.tenantsLabel'"
        [options]="tenants()"
        [optionValue]="'tenantId'"
        [optionLabel]="'name'"
        [placeholder]="'core.announcement.form.tenantsPlaceholder'">
      </nx-edit-multiselect-v2-input>

      @if (tenantsFailed()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.tenantsLoadErrorMessage' | translate }}</div>
      }
      @if (missingTenants()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorMissingTenants' | translate }}</div>
      }
    }

    <!-- Rollen stehen AUSSERHALB der Modus-Wache: Mandanten und Rollen sind serverseitig zwei
         unabhaengige Dimensionen. Die Modus-Pruefung zaehlt nur allTenants/tenantIds/
         correctsAnnouncement und sieht roles gar nicht (AnnouncementAdminServiceImpl:840); der
         Filter wirkt erst im Fan-out INNERHALB der gewaehlten Mandanten (ordinaryRecipients).
         `{ allTenants: true, roles: [...] }` ist ein ausdrueckliches Beispiel des Server-Doks
         (06-announcements.md, Abschnitt Targeting) — solange das Feld an der Auswahl hing, war
         genau diese Kombination unerreichbar, und ein Duplikat davon verlor seinen Rollenfilter
         still an ALLE.

         roles wird serverseitig NICHT validiert: ein Tippfehler erreicht still niemand. Genau
         deshalb Auswahl aus getRoles statt Freitext. -->
    <nx-edit-multiselect-v2-input
      formControlName="roles"
      [label]="'core.announcement.form.rolesLabel'"
      [options]="roles()"
      [optionValue]="'name'"
      [optionLabel]="'label'"
      [helpText]="'core.announcement.form.rolesHelp'"
      [placeholder]="'core.announcement.form.rolesPlaceholder'">
    </nx-edit-multiselect-v2-input>
    }
  </div>
  }

  <!-- Abschnitt 4: Versand -->
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.scheduleHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-3">
    @if (!beforeFanout() && mode() === 'EDIT') {
      <div class="text-[13px] text-[#848488]">{{ 'core.announcement.form.frozenAfterFanoutHint' | translate }}</div>
    } @else {
    <nx-edit-select-v2-input
      formControlName="scheduleMode"
      [label]="'core.announcement.form.scheduleLabel'"
      [options]="scheduleModeOptions | arrayTranslate"
      [optionValue]="'value'"
      [optionLabel]="'label'"
      [helpText]="'core.announcement.form.scheduleHelp'">
    </nx-edit-select-v2-input>

    @if (scheduleMode() === 'AT') {
      <div class="flex flex-col">
        <label>{{ 'core.announcement.form.scheduledAtLabel' | translate }}*</label>
        <p-calendar
          formControlName="scheduledAt"
          [showTime]="true"
          [showIcon]="true"
          [appendTo]="'body'"
          dateFormat="dd.mm.yy"
          [placeholder]="'core.announcement.form.scheduledAtPlaceholder' | translate">
        </p-calendar>
      </div>

      @if (missingScheduledAt()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorMissingScheduledAt' | translate }}</div>
      }
      <!-- Der Server prueft den Zeitpunkt NICHT gegen die Gegenwart und verschickt einen
           Vergangenheitstermin beim naechsten Fan-out-Lauf sofort an alle. -->
      @if (scheduledInPast()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorScheduledInPast' | translate }}</div>
      }
    }
    }
  </div>

  <!-- Abschnitt 4.5: Dashboard-Banner (Client-Dok §8.6). Bewusst NICHT hinter beforeFanout()
       versteckt wie Zielgruppe/Termin oben: dashboardUntil bleibt laut §8.3 auch nach dem
       Fan-out aenderbar, in JEDEM Modus (CREATE/EDIT/CORRECT). -->
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.dashboardHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-3">
    <nx-checkbox-text-input
      formControlName="dashboardBannerEnabled"
      [label]="'core.announcement.form.dashboardEnabledLabel' | translate">
    </nx-checkbox-text-input>

    @if (dashboardBannerEnabled()) {
      <div class="flex flex-col">
        <label>{{ 'core.announcement.form.dashboardUntilLabel' | translate }}*</label>
        <p-calendar
          formControlName="dashboardUntil"
          [showTime]="true"
          [showIcon]="true"
          [appendTo]="'body'"
          dateFormat="dd.mm.yy"
          [placeholder]="'core.announcement.form.dashboardUntilPlaceholder' | translate">
        </p-calendar>
      </div>

      @if (dashboardTtlDays()) {
        <div class="text-[13px] text-[#848488]">
          {{ 'core.announcement.form.dashboardTtlHint' | translate:{ days: dashboardTtlDays() } }}
        </div>
      }
      @if (missingDashboardUntil()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorMissingDashboardUntil' | translate }}</div>
      }
      @if (dashboardUntilBeforeSchedule()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorDashboardUntilBeforeSchedule' | translate }}</div>
      }
      @if (dashboardUntilExceedsTtl()) {
        <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorDashboardUntilExceedsTtl' | translate }}</div>
      }
    }

    <!-- sticky (Client-Dok §8.3): UNABHAENGIG von dashboardBannerEnabled — wirkt auch als reiner
         Glockeneintrag ohne Dashboard-Fenster. Deshalb hier zwar im selben Kartenblock (die
         Kurz-halten-Empfehlung bezieht sich auf das Fenster oben), aber ausserhalb von dessen
         @if. Ein Anhaken belegt ein leeres Fenster automatisch kurz vor (siehe
         prefillShortDashboardWindow()). -->
    <nx-checkbox-text-input
      formControlName="sticky"
      [label]="'core.announcement.form.stickyLabel' | translate">
    </nx-checkbox-text-input>
    <div class="text-[13px] text-[#848488]">{{ 'core.announcement.form.stickyHint' | translate }}</div>
  </div>

  <!-- Abschnitt 4.6: Externes Ziel (Client-Dok §8.7). Wie das Dashboard-Banner NICHT hinter
       beforeFanout() versteckt und in JEDEM Modus sichtbar — uriLink bleibt laut Doku ebenfalls
       nach dem Fan-out aenderbar. Eigener Name statt "Ziel"/"targetHeadline": das waere mit der
       "Zielgruppe" oben zu leicht zu verwechseln. -->
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.linkHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-1">
    <nx-edit-text-input
      formControlName="uriLink"
      [label]="'core.announcement.form.uriLinkLabel'"
      [placeholder]="'core.announcement.form.uriLinkPlaceholder'">
    </nx-edit-text-input>

    <div class="text-[13px] text-[#848488]">{{ 'core.announcement.form.uriLinkHint' | translate }}</div>

    @if (uriLinkNotAbsolute()) {
      <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorUriLinkNotAbsolute' | translate }}</div>
    }
    @if (uriLinkTooLong()) {
      <div class="text-[13px] text-[#c0123c]">{{ 'core.announcement.form.errorUriLinkTooLong' | translate }}</div>
    }
  </div>

  <!-- Abschnitt: Grund der Aenderung. Nur beim Bearbeiten — er landet in der Revisionshistorie
       (AnnouncementRevision) und beantwortet spaeter „warum stand da vorher etwas anderes".
       Beim Zurueckziehen gibt es kein Gegenstueck: dessen Grund geht nur ins Serverlog. -->
  @if (mode() === 'EDIT') {
    <nx-headline-box class="mt-2" [label]="'core.announcement.form.reasonHeadline'"></nx-headline-box>

    <div class="bg-white border-b border-gray px-5 py-4">
      <nx-edit-text-input
        formControlName="reason"
        [label]="'core.announcement.form.reasonLabel'"
        [placeholder]="'core.announcement.form.reasonPlaceholder'">
      </nx-edit-text-input>
    </div>
  }

  <!-- Abschnitt 5: Testversand. Eigener Abschnitt und nicht mehr in der Fusszeile: dort stand die
       Probe neben „Ankuendigung anlegen" und sah aus wie deren Variante, obwohl sie nichts anlegt.
       Nach dem Versand, weil sie den fertigen Entwurf probt. -->
  <nx-headline-box
    class="mt-2"
    [label]="'core.announcement.form.testHeadline'">
  </nx-headline-box>

  <div class="bg-white border-b border-gray px-5 py-4 flex flex-col gap-3">
    <!-- Vorschausprache: erzwingt die Rendersprache unabhaengig von der eigenen Spracheinstellung.
         So laesst sich die englische Fassung pruefen, ohne die eigene Sprache umzustellen.
         Als Formulareingabe statt als nx-filter-dropdown — die Pille mit Doppelpunkt-Beschriftung
         gehoert in eine Filterzeile, nicht in ein Formular.
         Nicht Teil des FormGroup: der Wert geht nicht in den Input, sondern als eigenes Argument
         der Mutation mit. Deshalb ngModel/standalone — eine NgControl braucht die Komponente
         trotzdem (Injector.get(NgControl) in ihrem ngOnInit). -->
    <nx-edit-select-v2-input
      [ngModel]="previewLocale()"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onPreviewLocaleChange($event)"
      [label]="'core.announcement.form.previewLocaleLabel'"
      [options]="localeOptions | arrayTranslate"
      [optionValue]="'value'"
      [optionLabel]="'label'"
      [helpText]="'core.announcement.form.testHelp'">
    </nx-edit-select-v2-input>

    @if (mode() === 'CORRECT') {
      <!-- sendTestAnnouncement kennt kein correctsAnnouncementId (CreateAnnouncementInput hat kein
           Feld dafuer): der Probeversand zeigt NIE das „Korrektur:"-Praefix und den Hinweisblock.
           Wer das nicht weiss, haelt es fuer einen Fehler. -->
      <div class="text-[13px] text-[#848488]">{{ 'core.announcement.form.testCorrectionHint' | translate }}</div>
    }

    <!-- sendTestAnnouncement prueft content und typeKey, aber NICHT targeting — der Entwurf laesst
         sich proben, bevor die Zielgruppe steht. Es wird nichts gespeichert, aber die eigene
         E-Mail bzw. Push geht wirklich raus.
         Eigene Zeile: im flex-col-Container zoege ihn align-items: stretch sonst auf die volle
         Breite. -->
    <div class="flex flex-row">
      <nx-default-button
        [style]="'light'"
        [disabled]="!canSendTest()"
        (click)="onSendTest()"
        [label]="testing() ? 'core.announcement.form.testingAction' : 'core.announcement.form.testAction'">
      </nx-default-button>
    </div>
  </div>

  <!-- Fusszeile: nur noch Verwerfen und Anlegen. -->
  <div class="bg-white px-5 py-4 border-b border-t mt-2 flex flex-row justify-end gap-2">
    <nx-default-button
      [style]="'transparent'"
      [disabled]="submitting()"
      (click)="onAbort()"
      [label]="'core.announcement.form.abortAction'">
    </nx-default-button>

    <!-- Waehrend des Sendens gesperrt, damit nicht zwei Ankuendigungen entstehen. -->
    <nx-default-button
      [style]="'dark'"
      [disabled]="!canSubmit()"
      (click)="onSubmit()"
      [label]="submitting() ? submittingLabelKey() : submitLabelKey()">
    </nx-default-button>
  </div>
</div>
